import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=23a457e6&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=23a457e6&prod&lang=stylus&scoped=true&"
import style1 from "./Upload.vue?vue&type=style&index=1&id=23a457e6&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a457e6",
  null
  
)

export default component.exports